import {cloneDeep} from 'lodash'
import $ from 'jquery'
import Vue from 'vue'

export default {
  data () {
    return {
      entries: [],
      loading: true,
      sort: 'name',
      sortDir: 'asc',
      defaultEntry: {},
      defaultEntryData: {
        name: null
      },
      selectedEntryId: null,
      headings: [
        { key: 'name', label: 'Name' }
      ]
    }
  },

  computed: {
    selectedEntryIndex () {
      if (this.selectedEntryId) {
        const index = this.entries.findIndex(element => element.id === this.selectedEntryId)
        if (index !== -1) {
          return index
        }
      }
      return -1
    },
    sortedEntries () {
      const entries = cloneDeep(this.entries)
      return entries.sort((a, b) => {
        let aValue = a[this.sort]
        let bValue = b[this.sort]
        if (typeof aValue === 'string') {
          aValue = aValue.toLowerCase()
        }
        if (typeof bValue === 'string') {
          bValue = bValue.toLowerCase()
        }
        if (this.sortDir === 'asc') {
          return aValue > bValue ? 1 : -1
        }
        return aValue < bValue ? 1 : -1
      })
    }
  },

  created () {
    this.defaultEntry = cloneDeep(this.defaultEntryData)
  },

  methods: {
    showModal () {
      $(this.$refs.modal.$el).modal('show')
    },

    showDepartmentsModal () {
      $(this.$refs.departmentsModal.$el).modal('show')
    },

    updateSort (key) {
      if (this.sort === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sort = key
        this.sortDir = 'asc'
      }
    },

    update (entry) {
      const index = this.entries.findIndex(element => element.id === entry.id)
      if (index !== -1) {
        Vue.set(this.entries, index, entry)
      }
    },

    add (entry) {
      this.entries.push(entry)
      this.defaultEntry = cloneDeep(this.defaultEntryData)
    }
  }
}
